import * as u from '@/utils/util'
import {sessionKey} from '@/utils/config'
import {router, createRouter} from './index.js'


var whiteList = ['/login', "/", '/share/preview']
const baseAdminChildren = router.options.routes[0].children.slice()

//获取路由树
function getRouter() {
   let tree= u.getSession(sessionKey.SYS_MENU_TREE);
   if(!tree || !Array.isArray(tree)){
    return [];
   }
   return buildRouterList(tree)
}


//构建路由集合
function buildRouterList(tree) {
  let routerList=[];
  tree.forEach(x=>{
    if(x.children!=null && x.children.length>0){
      buildRouterList(x.children).forEach(y=>{
        routerList.push(y)
      })
    }
    const component = 'view' + x.path
    if(x.type=="1"){
      routerList.push({
        path: x.path,
        name: x.name,
        meta: {
          title: x.name,
          keepAlive: x.cache=='Y'?true:false
        },
        component(resolve) {
          require([`../${component}.vue`], resolve)
        },
      })
    }
  })
  return routerList;
}

//  拦截
var intercept = false; // 页面刷新货初次加载 才会执行这个变量

export function resetPermissionState() {
  intercept = false;
  router.options.routes[0].children = baseAdminChildren.slice();
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

/*路由守卫*/
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title
  //判断当前用户token是否存在
  let token=u.getToken();
  //判断跳转的是否是不需要登录
  if(whiteList.indexOf(to.path)==-1){
    //需要登录
    //判断token是否存在
    if(token==null || token==''){
        //没有登录切换登录页面
      next("/login")
    } else{
      //设置动态
      // 当 qq 为false 表示 刷新了 或 第一次加载
      if (!intercept) {
        const dynamicRoutes = getRouter();
        if(dynamicRoutes.length > 0){
          intercept = true; // 仅在动态路由真实注入后再置位
          dynamicRoutes.forEach(x => {
            const component = 'view' + x.path
            router.options.routes[0].children.push({
              path: x.path,
              name: x.name,
              meta:x.meta,
              component(resolve) {
                require([`../${component}.vue`], resolve)
              },
            });
          })
          router.addRoutes(router.options.routes);
          next({ ...to, replace: true });
        }else{
          next();
        }
      }else{
        next();
      }
    }
  }else{
    //不需要登录的页面
    // 如果是分享页面且已登录，也需要加载动态路由（但不重定向）
    if(to.path === '/share/preview' && token && !intercept) {
      const userInfo = u.getSession(sessionKey.USER_INFO);
      // 只有在有用户信息的情况下才加载动态路由
      if(userInfo && userInfo.sysMenus) {
        intercept = true;
        getRouter().forEach(x => {
          const component = 'view' + x.path
          router.options.routes[0].children.push({
            path: x.path,
            name: x.name,
            meta:x.meta,
            component(resolve) {
              require([`../${component}.vue`], resolve)
            },
          });
        })
        router.addRoutes(router.options.routes);
      }
    }
    next();
  }
})

// 捕获路由错误，避免控制台报错
const originalPush = router.push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = router.replace
router.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
export default router;
